<template>
  <router-view />
</template>

<style lang="scss">
body {
  color: var(--font_main);
  background: var(--background_pic);
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  background-color: var(--background) !important;
}

#app {
  font-family: Montserrat, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-weight: 300;

  a {
    color: inherit;
    text-decoration: inherit;
  }
}
</style>
